import React, { useRef, useState, useEffect } from "react";
import { Line } from "react-chartjs-2";
import { useDispatch, useSelector } from "react-redux";
import { getLoans, getSettlements } from "./redux/actions/loansAndSettlements";

function NewChart() {
  const dispatch = useDispatch();

  const { loans, settlements } = useSelector(
    (state) => state.loansAndSettlements
  );

  useEffect(() => {
    dispatch(getLoans());
    dispatch(getSettlements());
  }, [dispatch]);

  // console.log("------------------------------");
  // console.log(loans);
  // console.log("------------------------------");

  // const datess = loans.map((loan) => loan.attributes.loanDate);

  // console.log("------------------------------");
  // console.log(datess);
  // console.log("------------------------------");

  // const initialDates = [
  //   "2021-08-25",
  //   "2021-08-26",
  //   "2021-08-27",
  //   "2021-08-28",
  //   "2021-08-29",
  //   "2021-08-30",
  //   "2021-08-31",
  // ];
  // [...new Set(loans.map((loan) => loan.attributes.loanDate))]

  const initialDates = [
    ...new Set(loans.map((loan) => loan.attributes.loanDate)),
  ];

  // const initialDataPoints = loans.map((loan) => ({
  //   num: loans.length,
  //   amount: loan.attributes.loanAmount,
  // }));

  // const initialDataPoints = loans.map((loan) => loans.length);
  const initialDataPoints = loans.map((loan) =>
    parseInt(loan.attributes.loanAmount)
  );
  // const initialDataPoints3 = settlements.map((settlement) =>
  //   parseInt(settlement.attributes.settledAmount)
  // );

  const initialDataPoints4 = initialDates.map(
    (xx) =>
      settlements.filter(
        (settlement) => settlement.attributes.settlementDate === xx
      ).length
  );

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    stacked: false,
    plugins: {
      title: {
        display: true,
        text: "Settlements and Loans Data",
      },
    },
    scales: {
      y: {
        type: "linear",
        display: true,
        position: "left",
      },
      y1: {
        type: "linear",
        display: true,
        position: "right",
        grid: {
          drawOnChartArea: false,
        },
      },
      y3: {
        type: "linear",
        display: true,
        position: "right",
        grid: {
          drawOnChartArea: false,
        },
      },
      y4: {
        type: "linear",
        display: true,
        position: "left",
        grid: {
          drawOnChartArea: false,
        },
      },
    },
  };

  // settlements.filter(
  //   (settlement) => settlement.attributes.settlementDate === "2022-06-08"
  // );

  console.log("------------------------------");
  console.log(initialDataPoints4);
  console.log("------------------------------");

  // const initialDataPoints = [1, 2, 4, 9, 12, 15, 16];

  const [dates, setDates] = useState(initialDates);
  const [dataPoints, setDataPoints] = useState(initialDataPoints);
  // const [dataPointss, setDataPointss] = useState(initialDataPoints2);

  console.log(dates, dataPoints);

  const inputRef1 = useRef();
  const inputRef2 = useRef();

  function filterData() {
    const dates2 = [...dates];
    const dataPoints2 = [...dataPoints];

    //slice the array
    let value1 = inputRef1.current.value;
    let value2 = inputRef2.current.value;
    const indexstartdate = dates2.indexOf(value1);
    const indexenddate = dates2.indexOf(value2);
    console.log(indexstartdate);
    console.log(indexenddate);
    //slice the array
    const filterDate = dates2.slice(indexstartdate, indexenddate + 1);
    const filterDataPoints = dataPoints2.slice(
      indexstartdate,
      indexenddate + 1
    );

    console.log(filterDate, filterDataPoints);

    //replace label in the chart
    //HELP HERE!!!

    setDates(filterDate);
    setDataPoints(filterDataPoints);
    console.log(dates, dataPoints);
  }

  return (
    <div>
      <div>
        <Line
          id="myChart"
          data={{
            labels: dates,

            datasets: [
              {
                label: "Total loan amount",
                data: initialDates.map((label) =>
                  loans
                    .map((loan) =>
                      loan.attributes.loanDate === label
                        ? parseInt(loan.attributes.loanAmount)
                        : 0
                    )
                    .reduce(
                      (previousValue, currentValue) =>
                        currentValue + previousValue,
                      0
                    )
                ),
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 206, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
                yAxisID: "y",
              },
              {
                label: "Total settlements amount",
                data: initialDates.map((label) =>
                  settlements
                    .map((settlement) =>
                      settlement.attributes.settlementDate === label
                        ? parseInt(settlement.attributes.settledAmount)
                        : 0
                    )
                    .reduce(
                      (previousValue, currentValue) =>
                        currentValue + previousValue,
                      0
                    )
                ),
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 206, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
                yAxisID: "y1",
              },
              {
                label: "Total no of settlements",
                data: initialDates.map(
                  (initialDate) =>
                    settlements.filter(
                      (settlement) =>
                        settlement.attributes.settlementDate === initialDate
                    ).length
                ),
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 206, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
                yAxisID: "y3",
              },
              {
                label: "Total no of loans",
                data: initialDates.map(
                  (initialDate) =>
                    loans.filter(
                      (loan) => loan.attributes.loanDate === initialDate
                    ).length
                ),
                backgroundColor: [
                  "rgba(255, 99, 132, 0.2)",
                  "rgba(54, 162, 235, 0.2)",
                  "rgba(255, 206, 86, 0.2)",
                  "rgba(75, 192, 192, 0.2)",
                  "rgba(153, 102, 255, 0.2)",
                  "rgba(255, 159, 64, 0.2)",
                ],
                borderColor: [
                  "rgba(255, 99, 132, 1)",
                  "rgba(54, 162, 235, 1)",
                  "rgba(255, 206, 86, 1)",
                  "rgba(75, 192, 192, 1)",
                  "rgba(153, 102, 255, 1)",
                  "rgba(255, 159, 64, 1)",
                ],
                borderWidth: 1,
                yAxisID: "y4",
              },
            ],
          }}
          height={400}
          width={400}
          options={options}
        />
      </div>
      <div className="px-4">
        From:{" "}
        <input
          type="date"
          name="loanDate"
          className="shadow-sm flex-grow mb-2 focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-72 sm:text-sm border-gray-300 rounded-md"
          ref={inputRef1}
        />
        To:
        <input
          type="date"
          name="loanDate"
          className="shadow-sm flex-grow  focus:ring-sky-500 focus:border-sky-500 flex w-full sm:w-72 sm:text-sm border-gray-300 rounded-md"
          ref={inputRef2}
        />
        <button
          className="mt-3 w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-sky-600 text-base font-medium text-white hover:bg-sky-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:w-auto sm:text-sm"
          onClick={filterData}
        >
          Filter Chart
        </button>
        <button
          type="button"
          className="mt-3 sm:ml-2 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 sm:mt-0 sm:w-auto sm:text-sm"
          onClick={() => {
            setDates(initialDates);
            setDataPoints(initialDataPoints);
          }}
        >
          Remove Filter
        </button>
      </div>
    </div>
  );
}

export default NewChart;
